import config from "../../config.json";
const BASE_AUTH_API = config.BASE_AUTH_API;
export const apiRequest = async ({ endpoint, method = "GET", token, body }) => {
  try {
    const response = await fetch(`${BASE_AUTH_API}${endpoint}`, {
      method,
      headers: {
        Accept: "application/json",
        Authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
      ...(body && {
        body: JSON.stringify(body),
      }),
    });

    const data = await response.json();

    if (!response.ok || !data.success) {
      throw new Error(data.message || "Request failed");
    }

    return data;
  } catch (error) {
    console.error(error);
    throw error;
  }
};

export const createSupportAPI = async (token, payload) => {
  const res = await apiRequest({
    endpoint: "support",
    method: "POST",
    token,
    body: payload,
  });

  return res.data;
};

export const getMySupportsAPI = async (
  token,
  { page = 1, limit = 20, status, category } = {},
) => {
  const params = new URLSearchParams();

  params.append("page", page);
  params.append("limit", limit);

  if (status) params.append("status", status);
  if (category) params.append("category", category);

  const res = await apiRequest({
    endpoint: `support?${params.toString()}`,
    token,
  });

  return res;
};

export const getSupportByIdAPI = async (token, supportId) => {
  const res = await apiRequest({
    endpoint: `support/${supportId}`,
    token,
  });

  return res.data;
};

export const addSupportMessageAPI = async (
  token,
  supportId,
  message,
  attachments = [],
) => {
  const res = await apiRequest({
    endpoint: `support/${supportId}/messages`,
    method: "POST",
    token,
    body: {
      message,
      attachments,
    },
  });

  return res;
};

export const closeSupportAPI = async (token, supportId) => {
  const res = await apiRequest({
    endpoint: `support/${supportId}/close`,
    method: "PATCH",
    token,
  });

  return res;
};

export const assignSupportAPI = async (token, supportIds, assignedTo) => {
  const res = await apiRequest({
    endpoint: `support/assign-bulk`,
    method: "PATCH",
    token,
    body: {
      supportIds,
      assignedTo,
    },
  });

  return res;
};

export const updateSupportStatusAPI = async (token, supportId, status) => {
  const res = await apiRequest({
    endpoint: `support/${supportId}/status`,
    method: "PATCH",
    token,
    body: {
      status,
    },
  });

  return res;
};

export const updateSupportPriorityAPI = async (token, supportId, priority) => {
  const res = await apiRequest({
    endpoint: `support/${supportId}/priority`,
    method: "PATCH",
    token,
    body: {
      priority,
    },
  });

  return res;
};

export const addInternalNoteAPI = async (token, supportId, message) => {
  const res = await apiRequest({
    endpoint: `support/${supportId}/internal-note`,
    method: "POST",
    token,
    body: {
      message,
    },
  });

  return res;
};

// export const getSupportStatsAPI = async (
//   token
// ) => {
//   const res = await apiRequest({
//     endpoint: "support/stats/dashboard",
//     token,
//   });

//   return res.data;
// };

export const getCategoriesAPI = async (token, active) => {
  const params = new URLSearchParams();

  if (active !== undefined) {
    params.append("active", active);
  }

  const query = params.toString();

  const res = await apiRequest({
    endpoint: query
      ? `support/categories/list?${query}`
      : "support/categories/list",
    token,
  });

  return res.data;
};

export const createCategoryAPI = async (token, payload) => {
  const res = await apiRequest({
    endpoint: "support/categories",
    method: "POST",
    token,
    body: payload,
  });

  return res.data;
};

export const updateCategoryAPI = async (token, categoryId, payload) => {
  const res = await apiRequest({
    endpoint: `support/categories/${categoryId}`,
    method: "PUT",
    token,
    body: payload,
  });

  return res.data;
};

/*
|--------------------------------------------------------------------------
| SLAs
|--------------------------------------------------------------------------
*/

export const deleteSupportAPI = async (token, supportId) => {
  const res = await apiRequest({
    endpoint: `support/${supportId}`,
    method: "DELETE",
    token,
  });

  return res;
};

export const fetchSupportUsersAPI = async (token) => {
  let responseData;
  try {
    await fetch(`${BASE_AUTH_API}support/users`, {
      method: "GET",
      headers: {
        Authorization: `Bearer ${token}`,
      },
    })
      .then((response) => response.json())
      .then((data) => (responseData = data));

    if (responseData.success) {
      return responseData.users;
    } else {
      return;
    }
  } catch (error) {
    console.log(error.message);
    return;
  }
};
